<template>
  <div class="menu">
    <div class="menu-content">
      <button class="menu-content__close" data-toggle=".menu">
        <Icon name="ri:close-large-line" />
        <span>{{ $t("menu.close") }}</span>
      </button>
      <div class="row overflow-hidden gx-6 md:gx-16">
        <div v-for="(menu, index) in navigation" :key="index" class="col-6">
          <nav v-for="group in menu" :key="group.title" class="menu-content__group">
            <div class="menu-content__group-title">{{ group.title }}</div>
            <div class="menu-content__group-links">
              <NuxtLinkLocale v-for="link in group.links" :key="link.link" :to="link.link">
                <span>{{ link.title }}</span>
                <i v-if="link?.description">{{ link.description }}</i>
              </NuxtLinkLocale>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <div class="menu-backdrop" data-toggle=".menu"></div>
  </div>
</template>

<script setup lang="ts">
  const { t } = useI18n()
  const navigation: any = computed(() => [
    // Sol sütun
    [
      {
        title: t("menu.zimmerHotels"),
        links: [
          { title: t("menu.rooms"), link: "/rooms" },
          { title: t("menu.about"), link: "/about" },
          { title: t("menu.explore"), link: "/explore" },
          { title: t("menu.transportation"), link: "/transportation" },
          { title: t("menu.transfer"), link: "/transfer" }
        ]
      },
      {
        title: t("menu.contact"),
        links: [
          { title: t("menu.contactLink"), link: "/contact" },
          { title: t("menu.humanResources"), link: "/human-resources" }
        ]
      },
      {
        title: t("menu.contracts"),
        links: [{ title: t("menu.membershipAgreement"), link: "/page/uyelik-sozlesmesi" }]
      }
    ],
    // Sağ sütun
    [
      {
        title: t("menu.roomsGroup"),
        links: [
          { title: t("roomTypes.suite.title"), description: t("roomTypes.suite.description"), link: "/rooms/suite" },
          { title: t("roomTypes.deluxe.title"), description: t("roomTypes.deluxe.description"), link: "/rooms/deluxe" },
          { title: t("roomTypes.standart.title"), description: t("roomTypes.standart.description"), link: "/rooms/standart" },
          { title: t("roomTypes.family.title"), description: t("roomTypes.family.description"), link: "/rooms/family" }
        ]
      },
      {
        title: t("menu.diningGroup"),
        links: [
          { title: t("diningTypes.lulu.title"), description: t("diningTypes.lulu.description"), link: "/explore/detail/lulu" },
          { title: t("diningTypes.pitza.title"), description: t("diningTypes.pitza.description"), link: "/explore/detail/pitza" }
        ]
      }
    ]
  ])
</script>

<style lang="scss" scoped>
  .menu {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 1001;
    color: #282828;
    display: flex;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.2s;

    &-content {
      flex: 1;
      background: #f2f0e9;
      display: flex;
      flex-direction: column;
      position: relative;
      z-index: 10;
      padding: 100px 48px 40px;
      overflow: auto;
      width: fit-content;
      transition: all 0.2s;
      transform: translateX(-100%);

      &__close {
        @apply absolute font-display inline-flex w-fit items-center justify-center gap-2.5 p-0 bg-transparent border-none text-center;
        @apply text-inherit text-3 font-bold leading-4 uppercase p-4 -m-4 mr-auto;

        @apply top-9.5 left-10;
        letter-spacing: 3px;

        :deep(svg) {
          @apply text-6;
        }
      }
      &__group {
        display: flex;
        flex-direction: column;
        gap: 12px;
        min-width: 240px;

        &-title {
          @apply font-display;
          color: #000;
          font-size: 18px;
          font-weight: 550;
          line-height: 34px;
          letter-spacing: 1.5px;
          text-transform: uppercase;
        }
        &-links {
          display: flex;
          flex-direction: column;
          gap: 12px;

          a {
            font-size: 16px;
            font-weight: 400;
            line-height: 1.5rem;
            color: #282828;
            display: flex;
            flex-direction: column;
            gap: 2px;

            i {
              font-family: Plantin, serif;
              font-weight: 500;
              font-size: 14px;
              font-style: italic;
              letter-spacing: 0;
              line-height: 1;
            }
          }
        }

        &:not(:last-child) {
          margin-bottom: 50px;
        }
      }
    }
    &-backdrop {
      position: absolute;
      width: 100vw;
      height: 100%;
      inset: 0;
      background: rgba(0, 0, 0, 0.5);
      cursor: default;
    }

    &.show {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
    &.show &-content {
      transform: translateX(0);
    }

    @include media("md") {
      width: 100%;

      &-content {
        padding: 64px 16px 16px;
        transform: translateX(0);

        &__close {
          @apply top-4.5 left-4 gap-2 text-3;
          letter-spacing: 2px;

          :deep(svg) {
            @apply text-5;
          }
        }
        &__group {
          gap: 8px;
          min-width: unset;
          width: 100%;

          &-title {
            font-size: 16px;
            line-height: 24px;
            letter-spacing: 1.25px;
          }
          &-links {
            gap: 8px;

            a {
              font-size: 14px;
              line-height: 1.25rem;
              gap: 3px;

              i {
                font-size: 12px;
              }
            }
          }

          &:not(:last-child) {
            margin-bottom: 28px;
          }
        }
      }
    }
  }
</style>
